import { render } from "./MDBAccordion.vue?vue&type=template&id=58d0f118"
import script from "./MDBAccordion.vue?vue&type=script&lang=js"
export * from "./MDBAccordion.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/projects/mdb5-repos/vue/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__